import React, { Fragment, useEffect, useState, useContext } from "react";
import styled, { css } from "styled-components";
import { Context } from "../context";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { Route, Redirect } from "react-router";
import './gs.css';
import './gs_add.css';
import { Layout } from './Layout';
import { dateFormat } from './utils';
import { Routes } from "./Routes";


export function Home(props) {
  const context = useContext(Context);
  return (<>
      {context.ready && <Routes/>}
      </>
  );
}
